import { request as sonataRequest } from 'sonata-react-components';

import { convertDatesToStringDateFilter } from '@/helpers/common/date.helper';

import type { Moment } from 'moment-timezone';
import type { PaginationResult } from 'sonata-static-storage/lib/common/common.types';
import type { Venue } from 'sonata-static-storage/lib/schemas/venue/venue.schema';
import type { Token } from './common.types';

type Filters = {
  date?: {
    beginDate?: Moment | string;
    endDate?: Moment | string;
  };
  country: Venue['country'] | null;
  groups: Venue['groups'] | null;
  order?: 'asc' | 'desc';
  search: string | null;
  itemsPerPage?: number;
  sortBy?: string;
  status: Venue['state'] | null;
};

type PaginationParams = {
  itemsPerPage?: number;
  limit?: number;
  page?: number;
};

type Payload = Filters & PaginationParams;

export function getVenues(payload: Payload, userId: string, token: Token): Promise<PaginationResult<Venue>> {
  return sonataRequest.makeRequest(
    `${taptap.config.backendUrlBase}shops/${userId}`,
    {
      data: {
        filterCountry: payload.country,
        filterDate: convertDatesToStringDateFilter(payload.date),
        filterGroups: payload.groups?.join() || null,
        filterIncludeShopTile: true, // TODO: Check if always true
        filterStatus: payload.status ?? undefined,
        filterString: payload.search ?? undefined,
        itemsPerPage: payload.itemsPerPage || 30,
        order: payload.order ?? 'desc',
        page: payload.page,
        sortBy: payload.sortBy ?? 'created'
      },
      method: 'POST'
    },
    token
  );
}

export function getVenuesByIds(ids: Venue['_id'][], userId: string, token: Token): Promise<Venue[]> {
  return sonataRequest.makeRequest(
    `${taptap.config.backendUrlBase}shops/${userId}/byIds`,
    {
      data: {
        itemsPerPage: 'unlimited',
        order: 'desc',
        page: 1,
        shops: ids,
        sortBy: 'created'
      },
      method: 'POST'
    },
    token
  );
}

export function getUserVenueCountries(userId: string, token: Token): Promise<string[]> {
  return sonataRequest.makeRequest(
    `${taptap.config.backendUrlBase}shops/countries/${userId}`,
    {
      method: 'GET'
    },
    token
  );
}

export function updateVenue(venue: Venue, userId: string, token: Token): Promise<Venue> {
  return sonataRequest.makeRequest(
    `${taptap.config.backendUrlBase}shop/${userId}/${venue._id}`,
    {
      data: venue,
      method: 'PUT'
    },
    token
  );
}

export function deleteVenue(venueId: Venue['_id'], userId: string, token: Token): Promise<void> {
  return sonataRequest.makeRequest(
    `${taptap.config.backendUrlBase}shop/${userId}/${venueId}`,
    {
      method: 'DELETE'
    },
    token
  );
}

export function postAddVenues(venues: Venue[], token: Token): Promise<Venue[]> {
  return sonataRequest.makeRequest(
    `${taptap.config.backendUrlBase}multiflight/venue/save-batch`,
    {
      data: { venues },
      method: 'POST'
    },
    token
  );
}
